/* ============================================================
   HEDDZ - cart drawer + upsell engine (Ben's Overhaul)

   NO PRICE IS HARDCODED IN THIS FILE. Every figure is derived at runtime
   from /cart.js, the buy-box payload, and /products/<addon>.js.

   TOTALS ARE DETERMINISTIC. We reconstruct the pre-credit base
   (total_price + total_discount) and subtract the first-order credit
   ourselves, so the drawer shows the same numbers every time.

   ONE CHECKOUT PATH. goToCheckout() is the only place that decides whether
   to route via /discount/<code>.

   EXTRA-TRIO ADD-ON ("grab one for a friend").
     A separate, unlisted product (handle ADDON_HANDLE, one variant, priced
     at the add-on price with the regular trio price as compare-at). It is
     ALWAYS a one-time line: never sent with a selling_plan, so it never
     renews, even when the trio itself is on subscribe & save.
     - trio in the cart, no add-on  -> unchecked row. Tap adds 1 add-on.
     - trio + add-on                -> checked row. Tap removes the add-on.
     - add-on with no trio          -> removed automatically.
     The add-on's quantity is capped at 1.
     If the add-on product does not exist or is unavailable, no row shows.

   OTHER OFFERS (only when there is no trio in the cart):
     - six pack one-time -> switch to subscribe & save
     - any single pod    -> upgrade to trio on subscribe & save

   Public API (used by heddz.js and the Ben buy box):
     window.Heddz.cartDrawer.open()
     window.Heddz.cartDrawer.close()
     window.Heddz.cartDrawer.refresh()
     window.Heddz.cartDrawer.addAndOpen(item)   // item = {id, quantity, selling_plan?}
   ============================================================ */
(function () {
  'use strict';

  var routes = (window.Heddz && window.Heddz.routes) || {};
  var CART_ADD = routes.cartAdd || '/cart/add.js';
  var CART_CHANGE = routes.cartChange || '/cart/change.js';
  if (CART_ADD.indexOf('.js') === -1) CART_ADD = '/cart/add.js';
  if (CART_CHANGE.indexOf('.js') === -1) CART_CHANGE = '/cart/change.js';
  var CART_GET = '/cart.js';
  var CHECKOUT_URL = '/checkout';
  var MONEY_FORMAT = (window.Heddz && window.Heddz.moneyFormat) || '${{amount}}';
  var ADDON_HANDLE = (window.Heddz && window.Heddz.addonHandle) || 'heddz-extra-trio';

  var POD_ROLES = ['relief', 'calm', 'focus'];
  var JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var GENERIC_ERR = 'sorry, that did not go through. please try again.';

  var TOGGLE_CSS = '' +
    '.hd-up{display:flex;align-items:center;gap:12px;width:100%;text-align:left;cursor:pointer;font-family:inherit;color:var(--ink,#2A2722);' +
      'background:rgba(255,255,255,.45);border:1px solid rgba(42,39,34,.14);border-radius:14px;padding:12px 14px;transition:border-color .2s ease,background .2s ease}' +
    '.hd-up:hover{border-color:rgba(42,39,34,.35)}' +
    '.hd-up.is-on{border-color:var(--ink,#2A2722);background:rgba(255,255,255,.7)}' +
    '.hd-up:disabled{opacity:.6;cursor:default}' +
    '.hd-up__box{width:22px;height:22px;flex:none;border-radius:7px;border:1.5px solid rgba(42,39,34,.35);display:grid;place-content:center;font-size:13px;font-weight:800;color:#fff;background:transparent;transition:all .2s ease}' +
    '.hd-up.is-on .hd-up__box{background:var(--ink,#2A2722);border-color:var(--ink,#2A2722)}' +
    '.hd-up__img{width:56px;height:56px;flex:none;border-radius:11px;overflow:hidden;background:var(--bg-deep,#ECE5D2)}' +
    '.hd-up__img img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.hd-up__txt{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}' +
    '.hd-up__h{font-size:14.5px;font-weight:650;line-height:1.3}' +
    '.hd-up__d{font-size:12.5px;color:var(--ink-2,#6E675A);line-height:1.35}' +
    '.hd-up__p{display:flex;flex-direction:column;align-items:flex-end;line-height:1.2;white-space:nowrap}' +
    '.hd-up__p s{font-size:11.5px;font-weight:500;color:var(--ink-3,#9A9384)}' +
    '.hd-up__p b{font-size:15px;font-weight:750}' +
    '.hd-up__p i{font-style:normal;font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--ink-3,#9A9384);margin-top:3px}' +
    '.hd-cd__plan--once{color:var(--ink-2,#6E675A)!important}' +
    '@keyframes hdPop{0%{transform:scale(1)}35%{transform:scale(1.14);color:var(--accent,#C25B3C)}100%{transform:scale(1)}}' +
    '[data-cd-now]{display:inline-block;transform-origin:right center}' +
    '[data-cd-now].hd-pop{animation:hdPop .5s cubic-bezier(.2,.8,.2,1)}' +
    '@media (prefers-reduced-motion:reduce){[data-cd-now].hd-pop{animation:none}}' +
    '.hd-cd__upproof{display:none!important}';

  /* ---------- money ---------- */

  function centsFromMoneyString(str) {
    if (typeof str !== 'string') return null;
    var cleaned = str.replace(/[^0-9.,]/g, '');
    if (!cleaned) return null;
    var m = cleaned.match(/^(.*)([.,])(\d{2})$/);
    if (m) {
      var whole = m[1].replace(/[.,]/g, '');
      return parseInt(whole || '0', 10) * 100 + parseInt(m[3], 10);
    }
    return parseInt(cleaned.replace(/[.,]/g, ''), 10) * 100;
  }

  function group(intPart, sep) {
    return intPart.replace(/(\d)(?=(\d{3})+$)/g, '$1' + sep);
  }

  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    var n = Math.abs(Math.round(cents));
    var whole = String(Math.floor(n / 100));
    var frac = String(n % 100);
    if (frac.length < 2) frac = '0' + frac;
    return MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount_no_decimals': return group(whole, ',');
        case 'amount_with_comma_separator': return group(whole, '.') + ',' + frac;
        case 'amount_no_decimals_with_comma_separator': return group(whole, '.');
        case 'amount_with_apostrophe_separator': return group(whole, "'") + '.' + frac;
        default: return group(whole, ',') + '.' + frac;
      }
    });
  }

  /* $12.00 -> $12, $38.40 stays $38.40 */
  function short(cents) {
    return money(cents).replace(/[.,]00(?=[^0-9]*$)/, '');
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function errText(e, fallback) {
    if (!e) return fallback;
    if (typeof e === 'string') return e;
    return e.description || e.message || fallback;
  }

  /* ---------- buy-box payload (products, plans, intro discount) ---------- */

  var payload = null;

  function getPayload() {
    if (payload !== null) return payload;
    var el = document.querySelector('script[data-buybox-json]');
    if (!el) { payload = false; return payload; }
    try { payload = JSON.parse(el.textContent); } catch (e) { payload = false; }
    return payload;
  }

  /* ---------- extra-trio add-on product ---------- */

  var addon = null; /* null = not loaded yet, false = not available */
  var addonLoading = null;

  function loadAddon() {
    if (addon !== null) return Promise.resolve(addon);
    if (addonLoading) return addonLoading;
    addonLoading = fetch('/products/' + encodeURIComponent(ADDON_HANDLE) + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (p) {
        var v = p && p.variants && p.variants[0];
        addon = (v && v.available) ? {
          variantId: v.id,
          price: v.price,
          compare: v.compare_at_price,
          image: p.featured_image || (p.images && p.images[0]) || ''
        } : false;
        return addon;
      })
      .catch(function () { addon = false; return addon; });
    return addonLoading;
  }

  function roleMap() {
    var p = getPayload();
    var map = {};
    if (p && p.products) {
      Object.keys(p.products).forEach(function (role) {
        var v = p.products[role] && p.products[role].variantId;
        if (v) map[String(v)] = role;
      });
    }
    if (addon && addon.variantId) map[String(addon.variantId)] = 'addon';
    return map;
  }

  function productFor(role) {
    var p = getPayload();
    return (p && p.products && p.products[role]) || null;
  }

  function introConfig() {
    var p = getPayload();
    var i = (p && p.intro) || (window.Heddz && window.Heddz.intro) || null;
    if (!i || !i.code || !i.amountCents) return null;
    return { code: i.code, amountCents: i.amountCents, roles: i.roles || [] };
  }

  function planFor(role) {
    var prod = productFor(role);
    if (!prod || !prod.plans || !prod.plans.length) return null;

    var plans = prod.plans;
    var chosen = null;
    for (var i = 0; i < plans.length; i++) {
      if (plans[i].adjustments > 1) { chosen = plans[i]; break; }
    }
    if (!chosen) chosen = plans[0];

    var firstCents = chosen.firstCents != null ? chosen.firstCents : centsFromMoneyString(chosen.firstMoney);
    var recurCents = chosen.recurringCents != null ? chosen.recurringCents : centsFromMoneyString(chosen.recurringMoney);
    if (recurCents == null) recurCents = firstCents;

    var planHasIntro = chosen.adjustments > 1;

    var intro = introConfig();
    var introCents = null;
    if (planHasIntro) {
      introCents = firstCents;
    } else if (intro && intro.roles.indexOf(role) > -1 && firstCents != null) {
      introCents = Math.max(0, firstCents - intro.amountCents);
    }

    return {
      id: chosen.id,
      name: chosen.name,
      recurringCents: recurCents,
      introCents: introCents,
      hasIntro: introCents != null && recurCents != null && introCents < recurCents,
      viaDiscountCode: !planHasIntro && introCents != null
    };
  }

  /* ---------- cart ---------- */

  function readJson(r) {
    return r.json().then(function (data) {
      if (!r.ok) throw data;
      return data;
    }, function () {
      throw { description: GENERIC_ERR };
    });
  }

  function fetchCart() {
    return fetch(CART_GET, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(readJson);
  }

  function changeLine(key, quantity, extra) {
    var body = { id: key, quantity: quantity };
    if (extra) Object.keys(extra).forEach(function (k) { body[k] = extra[k]; });
    return fetch(CART_CHANGE, {
      method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(readJson);
  }

  function addItem(item) {
    return fetch(CART_ADD, {
      method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin',
      body: JSON.stringify({ items: [item] })
    }).then(readJson);
  }

  function annotate(cart) {
    var map = roleMap();
    return (cart.items || []).map(function (line) {
      var alloc = line.selling_plan_allocation || null;
      return {
        line: line,
        key: line.key,
        role: map[String(line.id)] || null,
        isSub: !!(alloc && alloc.selling_plan && alloc.selling_plan.id),
        planName: alloc && alloc.selling_plan ? alloc.selling_plan.name : null
      };
    });
  }

  function updateBadge(count) {
    var nodes = document.querySelectorAll('[data-cart-count], .hdr__cart-count');
    Array.prototype.forEach.call(nodes, function (n) {
      n.textContent = count;
      if (count > 0) { n.removeAttribute('hidden'); }
      else { n.setAttribute('hidden', ''); }
    });
  }

  /* ---------- upsell decision ---------- */

  function decide(rows) {
    function find(role, sub) {
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].role === role && (sub == null || rows[i].isSub === sub)) return rows[i];
      }
      return null;
    }

    var trioRow = find('trio') || find('double');
    var addonRow = find('addon');

    if (addonRow && !trioRow) return { type: 'orphan', row: addonRow };
    if (addonRow && addonRow.line.quantity > 1) return { type: 'cap', row: addonRow };

    if (trioRow) {
      if (addon && addon.variantId) return { type: 'addon', row: addonRow, on: !!addonRow };
      if (find('trio', true) || find('double', true)) return { type: 'won' };
      return null;
    }

    var sixOnce = find('double', false);
    if (sixOnce && planFor('double')) return { type: 'plan', role: 'double', row: sixOnce };

    for (var i = 0; i < rows.length; i++) {
      if (POD_ROLES.indexOf(rows[i].role) > -1 && planFor('trio')) {
        return { type: 'upgrade', role: 'trio', row: rows[i] };
      }
    }

    return null;
  }

  function toggleHtml(d) {
    if (!addon) return '';
    var on = d.on;
    var price = short(addon.price);
    var anchor = addon.compare && addon.compare > addon.price ? short(addon.compare) : '';
    if (!anchor) { var t = productFor('trio'); if (t && t.price > addon.price) anchor = short(t.price); }
    var src = addon.image || '';
    if (src && src.indexOf('//') === 0) src = 'https:' + src;
    return '' +
      '<button type="button" class="hd-up' + (on ? ' is-on' : '') + '" data-cd-take aria-pressed="' + (on ? 'true' : 'false') + '">' +
        '<span class="hd-up__box" aria-hidden="true">' + (on ? '&#10003;' : '') + '</span>' +
        (src ? '<span class="hd-up__img"><img src="' + esc(src) + '" alt=""></span>' : '') +
        '<span class="hd-up__txt">' +
          '<span class="hd-up__h">' + (on ? 'one for a friend, added' : 'grab one for a friend') + '</span>' +
          '<span class="hd-up__d">' + (on ? 'extra trio added for ' + price + '.' : 'get an extra trio for ' + price + '.') + '</span>' +
        '</span>' +
        '<span class="hd-up__p">' +
          (anchor ? '<s>' + anchor + '</s>' : '') +
          '<b>+' + price + '</b>' +
          '<i>one-time</i>' +
        '</span>' +
      '</button>' +
      '<p class="hd-cd__err" data-cd-up-err hidden></p>';
  }

  function offerCopy(decision) {
    var plan = planFor(decision.role);
    if (!plan) return null;

    var p = getPayload();
    var setg = (p && p.settings) || {};
    var subName = setg.subscribeName || 'subscribe & save';
    var names = setg.bundleNames || {};
    var label = names[decision.role] || decision.role;

    var recur = money(plan.recurringCents);
    var priceLine = plan.hasIntro
      ? '<b>' + money(plan.introCents) + '</b> on your first order (then ' + recur + ' after).'
      : '<b>' + recur + '</b> on every order.';

    if (decision.type === 'upgrade') {
      return {
        kicker: 'upgrade',
        head: 'three intents, nothing wasted',
        body: 'trade up to ' + esc(label) + ': ' + priceLine,
        btn: 'upgrade to ' + label,
        then: 'we swap the single pod out of your cart. skip or cancel anytime.'
      };
    }

    return {
      kicker: subName,
      head: 'never run dry',
      body: priceLine,
      btn: 'switch to ' + subName,
      then: 'skip, swap scents, or cancel anytime.'
    };
  }

  function cartHasPlan(cart, variantId, planId) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var alloc = it.selling_plan_allocation;
      if (String(it.id) === String(variantId) && alloc && alloc.selling_plan &&
          String(alloc.selling_plan.id) === String(planId)) return true;
    }
    return false;
  }

  function applyOffer(decision) {
    var row = decision.row || null;
    var oldKey = row ? row.key : null;

    if (decision.type === 'addon') {
      if (decision.on && oldKey) return changeLine(oldKey, 0);
      if (!addon || !addon.variantId) return Promise.reject({ description: 'that is not available right now.' });
      /* never a selling_plan: the extra trio is always one-time */
      return addItem({ id: addon.variantId, quantity: 1 });
    }

    var prod = productFor(decision.role);
    function addThenRemove(newItem, leftoverMsg) {
      return addItem(newItem).then(function () {
        if (!oldKey) return null;
        return changeLine(oldKey, 0).catch(function (e) {
          throw { description: leftoverMsg, cause: e };
        });
      });
    }

    var plan = planFor(decision.role);
    if (!prod || !prod.variantId || !plan) return Promise.reject({ description: 'this upgrade is not available right now.' });

    var qty = row && row.line ? (row.line.quantity || 1) : 1;
    if (decision.type === 'upgrade') qty = 1;

    var newItem = { id: prod.variantId, quantity: qty, selling_plan: plan.id };
    var leftover = 'added your subscription, but the one-time item is still in the cart. please remove it.';

    if (decision.type === 'plan' && oldKey) {
      return changeLine(oldKey, qty, { selling_plan: plan.id })
        .then(function (cart) {
          if (cartHasPlan(cart, prod.variantId, plan.id)) return cart;
          return addThenRemove(newItem, leftover);
        })
        .catch(function () { return addThenRemove(newItem, leftover); });
    }

    return addThenRemove(newItem, leftover);
  }

  /* ---------- rendering ---------- */

  var el = {};
  var lastRows = [];
  var lastDecision = null;

  function q(sel) { return el.root ? el.root.querySelector(sel) : null; }

  function bind() {
    el.root = document.querySelector('[data-cart-drawer]');
    if (!el.root) return false;

    if (el.root.parentNode !== document.body) document.body.appendChild(el.root);

    if (!document.getElementById('hd-up-css')) {
      var st = document.createElement('style');
      st.id = 'hd-up-css';
      st.textContent = TOGGLE_CSS;
      document.head.appendChild(st);
    }

    el.items = q('[data-cd-items]');
    el.upsell = q('[data-cd-upsell]');
    el.urg = q('[data-cd-urg]');
    el.was = q('[data-cd-was]');
    el.now = q('[data-cd-now]');
    el.note = q('[data-cd-note]');
    el.checkout = q('[data-cd-checkout]');
    el.err = q('[data-cd-err]');
    return true;
  }

  function showErr(msg) {
    if (!el.err) return;
    el.err.textContent = msg;
    el.err.hidden = false;
  }
  function clearErr() { if (el.err) el.err.hidden = true; }

  function showOfferErr(msg) {
    var box = q('[data-cd-up-err]');
    if (!box) { showErr(msg); return; }
    box.textContent = msg;
    box.hidden = false;
  }

  function lineHtml(row) {
    var line = row.line;
    var isAddon = row.role === 'addon';
    var img = line.image
      ? '<img src="' + esc(line.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2')) + '" alt="">'
      : '';
    var unit = line.final_line_price != null ? line.final_line_price : line.line_price;
    var was = line.original_line_price;
    if (isAddon && addon && addon.compare && addon.compare > addon.price) was = addon.compare * line.quantity;
    var wasLine = (was != null && was > unit) ? '<s>' + money(was) + '</s>' : '';
    var planTag = row.planName
      ? '<span class="hd-cd__plan">' + esc(row.planName) + '</span>'
      : (isAddon ? '<span class="hd-cd__plan hd-cd__plan--once">one-time · won\u2019t renew</span>' : '');

    return '' +
      '<li class="hd-cd__row">' +
        '<span class="hd-cd__thumb">' + img + '</span>' +
        '<span>' +
          '<span class="hd-cd__nm">' + esc(line.product_title) + '</span>' +
          planTag +
          (isAddon ? '' :
          '<span class="hd-cd__qtyrow">' +
            '<button type="button" class="hd-cd__qbtn" data-cd-dec="' + esc(row.key) + '" aria-label="decrease quantity"' + (line.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>' +
            '<span class="hd-cd__qn">' + line.quantity + '</span>' +
            '<button type="button" class="hd-cd__qbtn" data-cd-inc="' + esc(row.key) + '" aria-label="increase quantity">+</button>' +
          '</span>') +
          '<button type="button" class="hd-cd__rm" data-cd-rm="' + esc(row.key) + '">remove</button>' +
        '</span>' +
        '<span class="hd-cd__pr">' + wasLine + money(unit) + '</span>' +
      '</li>';
  }

  function render(cart) {
    updateBadge(cart.item_count || 0);
    if (!el.root) return;

    var rows = annotate(cart);
    lastRows = rows;

    var decision = rows.length ? decide(rows) : null;

    /* keep the add-on honest: never alone, never more than one */
    if (decision && (decision.type === 'orphan' || decision.type === 'cap')) {
      changeLine(decision.row.key, decision.type === 'orphan' ? 0 : 1).then(render).catch(function () {});
      return;
    }
    lastDecision = decision;

    if (!rows.length) {
      el.items.innerHTML = '<li class="hd-cd__empty">your cart is empty.</li>';
    } else {
      el.items.innerHTML = rows.map(lineHtml).join('');
    }

    var pending = pendingIntro(rows);
    var alreadyOff = cart.total_discount || 0;
    var base = (cart.total_price || 0) + alreadyOff;
    var credit = pending ? pending.amountCents : alreadyOff;
    var nowCents = Math.max(0, base - credit);

    if (el.now) {
      var prevNow = el.now.textContent;
      var nextNow = money(nowCents);
      el.now.textContent = nextNow;
      if (prevNow && prevNow !== nextNow) {
        el.now.classList.remove('hd-pop');
        void el.now.offsetWidth;
        el.now.classList.add('hd-pop');
      }
    }
    if (el.was) {
      if (base > nowCents) { el.was.textContent = money(base); el.was.hidden = false; }
      else { el.was.hidden = true; }
    }
    if (el.note) {
      if (credit > 0 && rows.length) {
        el.note.textContent = 'includes your ' + money(credit) + ' first-order credit';
        el.note.hidden = false;
      } else {
        el.note.hidden = true;
      }
    }

    if (!decision) {
      el.upsell.hidden = true;
      el.upsell.innerHTML = '';
    } else if (decision.type === 'addon') {
      var html = toggleHtml(decision);
      el.upsell.hidden = !html;
      el.upsell.innerHTML = html;
    } else if (decision.type === 'won') {
      el.upsell.hidden = false;
      el.upsell.innerHTML =
        '<div class="hd-cd__won">' +
          '<p class="hd-cd__won-h">you are all set.</p>' +
          '<p class="hd-cd__won-b">your bundle is on subscribe &amp; save. skip, swap scents or cancel anytime.</p>' +
        '</div>';
    } else {
      var copy = offerCopy(decision);
      if (!copy) {
        el.upsell.hidden = true;
        el.upsell.innerHTML = '';
      } else {
        el.upsell.hidden = false;
        el.upsell.innerHTML =
          '<div class="hd-cd__up">' +
            '<div class="hd-cd__up-k">' + esc(copy.kicker) + '</div>' +
            '<p class="hd-cd__up-h">' + esc(copy.head) + '</p>' +
            '<p class="hd-cd__up-b">' + copy.body + '</p>' +
            '<button type="button" class="hd-cd__up-btn" data-cd-take>' + esc(copy.btn) + '</button>' +
            '<p class="hd-cd__err" data-cd-up-err hidden></p>' +
            '<p class="hd-cd__up-then">' + esc(copy.then) + '</p>' +
          '</div>';
      }
    }
  }

  function pendingIntro(rows) {
    var intro = introConfig();
    if (!intro) return null;
    var havePayload = !!getPayload();
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (!r.isSub) continue;
      if (!havePayload || !r.role) return intro;
      if (intro.roles.length && intro.roles.indexOf(r.role) === -1) continue;
      var plan = planFor(r.role);
      if (plan && plan.viaDiscountCode) return intro;
    }
    return null;
  }

  /* ---------- open / close ---------- */

  var lastFocus = null;

  function open() {
    if (!el.root) return;
    lastFocus = document.activeElement;
    el.root.hidden = false;
    requestAnimationFrame(function () { el.root.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    var closeBtn = q('.hd-cd__x');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!el.root) return;
    el.root.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { if (!el.root.classList.contains('is-open')) el.root.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function refresh() {
    return loadAddon().then(fetchCart).then(function (cart) { render(cart); return cart; });
  }

  function addAndOpen(item) {
    clearErr();
    return addItem(item)
      .then(refresh)
      .then(function (cart) { open(); return cart; })
      .catch(function (e) {
        open();
        showErr(errText(e, 'sorry, we could not add that. please try again.'));
        throw e;
      });
  }

  /* ---------- events ---------- */

  function closestOf(node, sel) {
    while (node && node !== document) {
      if (node.nodeType === 1 && node.matches && node.matches(sel)) return node;
      node = node.parentNode;
    }
    return null;
  }

  function takeOffer(btn) {
    clearErr();
    if (!lastDecision || btn.disabled) return;
    var decision = lastDecision;
    var isToggle = btn.classList.contains('hd-up');
    var label = btn.textContent;
    btn.disabled = true;
    if (!isToggle) btn.textContent = 'switching…';
    applyOffer(decision)
      .then(refresh)
      .catch(function (err) {
        return refresh().catch(function () {}).then(function () {
          var b = q('[data-cd-take]');
          if (b) { b.disabled = false; if (!isToggle) b.textContent = label; }
          showOfferErr(errText(err, 'could not update your cart.'));
        });
      });
  }

  function wire() {
    el.root.addEventListener('click', function (e) {
      var t = e.target;

      if (closestOf(t, '[data-cd-close]')) { e.preventDefault(); close(); return; }

      var inc = closestOf(t, '[data-cd-inc]');
      var dec = closestOf(t, '[data-cd-dec]');
      var rm = closestOf(t, '[data-cd-rm]');
      var take = closestOf(t, '[data-cd-take]');

      if (inc || dec || rm) {
        e.preventDefault();
        clearErr();
        var key = inc ? inc.getAttribute('data-cd-inc')
                : dec ? dec.getAttribute('data-cd-dec')
                : rm.getAttribute('data-cd-rm');
        var row = null;
        for (var i = 0; i < lastRows.length; i++) { if (lastRows[i].key === key) row = lastRows[i]; }
        if (!row) return;
        var qty = rm ? 0 : (inc ? row.line.quantity + 1 : row.line.quantity - 1);
        changeLine(key, qty).then(render).catch(function (err) {
          showErr(errText(err, 'could not update your cart.'));
        });
        return;
      }

      if (take) {
        e.preventDefault();
        takeOffer(take);
        return;
      }

      if (closestOf(t, '[data-cd-checkout]')) {
        e.preventDefault();
        goToCheckout();
      }
    });

    document.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button && e.button !== 0)) return;

      if (closestOf(e.target, '[data-cart-open]')) {
        e.preventDefault();
        open();
        refresh().catch(function () {});
        return;
      }

      if (closestOf(e.target, '[data-cart-page-checkout]')) {
        e.preventDefault();
        refresh().then(goToCheckout).catch(goToCheckout);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.root && el.root.classList.contains('is-open')) close();
    });
  }

  function goToCheckout() {
    var pending = pendingIntro(lastRows);
    if (el.checkout) el.checkout.disabled = true;
    if (pending) {
      window.location.href = '/discount/' + encodeURIComponent(pending.code) +
        '?redirect=' + encodeURIComponent(CHECKOUT_URL);
    } else {
      window.location.href = CHECKOUT_URL;
    }
  }

  /* ---------- boot ---------- */

  function init() {
    if (!bind()) return;
    wire();
    refresh().catch(function () {});

    window.Heddz = window.Heddz || {};
    window.Heddz.cartDrawer = {
      open: open,
      close: close,
      refresh: refresh,
      addAndOpen: addAndOpen
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () { payload = null; refresh().catch(function () {}); });
})();
